import { FC } from "react";
import { ButtonPago } from "../../ui";
import { EligeCantidadPagoProps, PaymentOption } from "@/types";

// 🔹 Monto por cada opción de pago
const paymentValues: Record<Exclude<PaymentOption, "">, number> = {
  Mensual: 40,
  Semestral: 180,
  Anual: 240,
};

const EligeCantidadPago: FC<EligeCantidadPagoProps> = ({
  selectedPaymentOption,
  setSelectedPaymentOption,
  setPaymentAmount,
  errors,
  onPaymentChange,
}) => {
  // 🔹 Maneja clic sobre una opción
  const handleClick = (option: Exclude<PaymentOption, "">) => {
    const amount = paymentValues[option];
    setSelectedPaymentOption?.(option);
    setPaymentAmount?.(amount);
    onPaymentChange?.(option, amount);
  };

  return (
    <div className="w-full flex flex-col md:flex-row gap-2">
      {(["Mensual", "Semestral", "Anual"] as Exclude<PaymentOption, "">[]).map((option) => (
        <ButtonPago
          key={option}
          option={option}
          onClick={() => handleClick(option)}
          isSelected={selectedPaymentOption === option}
          paymentMethodError={!!errors.payment}
          className="flex-1 w-full md:w-auto flex flex-col items-center justify-center text-center truncate"
        >
          <span className="truncate">{option}</span>
          <span>{paymentValues[option]} €</span><p className="text-[10px]"> (+ IVA)</p>
        </ButtonPago>
      ))}
    </div>
  );
};

export default EligeCantidadPago;